import React from 'react';
import { Switch, withStyles } from '@material-ui/core'

const IOSSwitch = withStyles((theme) => ({
    switchBase: {
      color: "#aeffbd",
      "&$checked": {
        color: "#ea7071",
        "& + $track": {
          backgroundColor: "#b70000",
          opacity: 1
        }
      },
      "&$focusVisible $thumb": {
        color: "#52d869",
        border: "6px solid #fff"
      }
    },
    thumb: {
      width: 18,
      height: 18,
      marginLeft:2
    },
    track: {
      backgroundColor: "#00b700",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
    focusVisible: {}
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked
        }}
        {...props}
      />
    );
  });

  export default IOSSwitch